import React, {ForwardedRef, useMemo} from 'react';
import {View, Animated} from 'react-native';
import ContentEmpty from 'design-system/src/Components/ContentEmpty/ContentEmpty';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import SectionPageContent, {
  ISectionPageContentRef,
} from './SectionPageContent/SectionPageContent';
import {ContentSource} from '~Umbraco/Components/ContextualContentSlider/ContextualContentSlider';
import {Helmet} from 'react-helmet';
import {PAGE_TITLE_KEYS_BY_UMBRACO_IDS} from '@src/Constant/pageTitleTranslationMapping.constant';

function getTranslationKeyFromId(id: string): string | undefined {
  for (const [key, ids] of Object.entries(PAGE_TITLE_KEYS_BY_UMBRACO_IDS)) {
    if (ids.includes(id)) return key;
  }
  return undefined;
}

interface ISectionPageProps {
  id?: string;
  title?: string;
  animatedValue?: Animated.Value;
  contentSource: ContentSource;
}
const SectionPage = (
  props: ISectionPageProps,
  ref: ForwardedRef<ISectionPageContentRef>,
) => {
  const {id, title, contentSource, animatedValue} = props;
  const {t} = useTranslation('translation');

  const pageTitle = useMemo(() => {
    let base = 'Trace+';
    if (!id) return base;
    const translationKey = getTranslationKeyFromId(id);
    if (translationKey === 'HOME') return base; // Return Trace+ for home section

    const translatedPageTitle = translationKey ? t(translationKey) : '';
    return base + (translatedPageTitle ? ` ${translatedPageTitle}` : '');
  }, [id, t]);

  return id ? (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <SectionPageContent
        ref={ref}
        id={id}
        title={title}
        animatedValue={animatedValue}
        contentSource={contentSource}
      />
    </>
  ) : (
    <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
      <ContentEmpty title={t('Section not found')} />
    </View>
  );
};

export default React.memo(
  React.forwardRef<ISectionPageContentRef, ISectionPageProps>(SectionPage),
);
